import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  //   Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "2022", value: 100 },
  { name: "2023", value: 150 },
  { name: "2024", value: 240 },
  { name: "2025", value: 300 },
  { name: "2026", value: 495 },
  { name: "2027", value: 600 },
  { name: "2028", value: 750 },
  { name: "2029", value: 1050 },
  { name: "2030", value: 1450 },
  { name: "2031", value: 1950 },
  { name: "2032", value: 2750 },
];

// const renderCustomTooltip = ({ payload }) => {
//   if (payload && payload.length > 0) {
//     const dataPoint = payload[0].payload;
//     return (
//       <div className="custom-tooltip">
//         <p>{dataPoint.name}</p>
//         <p
//           style={{ color: "rgb(53, 162, 235)" }}
//         >{`Number of global active device connections in billions: ${dataPoint.value}`}</p>
//       </div>
//     );
//   }
//   return null;
// };

const HmcGlobalMarketChart = () => {
  return (
    <div>
      <div className="ml-16 mb-7">
        <p className="text-left text-base font-bold mb-0">
          Global AI Market Size
        </p>
        <span>($ Billions)</span>
        <sup className="text-[10px]">4</sup>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid vertical={false} />
          <XAxis dataKey="name" />
          <YAxis tickFormatter={(value) => `$${value.toLocaleString()}`} />
          {/* <Tooltip content={renderCustomTooltip} /> */}
          {/* <Tooltip /> */}
          {/* <Legend /> */}
          <Bar
            dataKey="value"
            fill="#C39F5C"
            animationBegin={500}
            animationDuration={1000}
            barSize={15}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default HmcGlobalMarketChart;
